'use client';

import * as React from 'react';

import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

import { cn } from '../lib/utils';

const RadioGroup: React.FC<
  React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Root>
> = ({ className, ...props }) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-2', className)}
      {...props}
    />
  );
};
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem: React.FC<
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
> = ({ className, ...props }) => {
  return (
    /*
     * Kasten mobil 44 px, sichtbare Marke 16 px — Begruendung und Messung im
     * Kopf von `checkbox.tsx` (Blatt A2, Blatt M, B-6). Am Rechner unveraendert.
     */
    <RadioGroupPrimitive.Item
      className={cn(
        'group flex h-11 w-4 shrink-0 items-center justify-center focus:outline-hidden focus-visible:outline-hidden disabled:cursor-not-allowed md:h-4',
        className,
      )}
      {...props}
    >
      {/*
        Gewählt = Indigo (`primary`), überall — Auswahl ist ein Zustand, keine
        Handlung; Vermillion bleibt der Handlung (Koordinator/Auftraggeber
        06.10.2026, `farbsystem.md` Entscheidung 3). Damit ist die Ausnahme
        `inKachel` entfallen: jeder Punkt trägt dieselbe Farbe.
      */}
      <span
        data-test="radio-ring"
        className="border-muted-2 group-focus-visible:ring-ring group-disabled:border-muted group-disabled:bg-muted group-data-[state=checked]:border-primary flex aspect-square h-4 w-4 items-center justify-center rounded-full border group-focus-visible:ring-2 group-focus-visible:ring-offset-2"
      >
        <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
          <span
            data-test="radio-punkt"
            className="bg-primary size-2 rounded-full"
          />
        </RadioGroupPrimitive.Indicator>
      </span>
    </RadioGroupPrimitive.Item>
  );
};
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

const RadioGroupItemLabel = (
  props: React.PropsWithChildren<{
    className?: string;
    selected?: boolean;
  }>,
) => {
  return (
    <label
      data-selected={props.selected}
      className={cn(
        props.className,
        'flex cursor-pointer rounded-lg' +
          ' border-input items-center space-x-4 border' +
          ' focus-within:border-primary active:bg-tint p-2.5 text-sm transition-all',
        {
          [`bg-tint/60`]: props.selected,
          [`hover:bg-surface`]: !props.selected,
        },
      )}
    >
      {props.children}
    </label>
  );
};
RadioGroupItemLabel.displayName = 'RadioGroupItemLabel';

export { RadioGroup, RadioGroupItem, RadioGroupItemLabel };
